import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

/** Sets the tab title to "Page | No Conflict Clearance" (the product name alone without a page). */
export function useDocumentTitle(page?: string): void {
  const { t } = useTranslation();
  const product = t('productName');
  const title = page ? t('documentTitle', { page, product }) : product;
  useEffect(() => {
    document.title = title;
  }, [title]);
}
